module.exports = __webpack_public_path__ + "img/mesa_l001a.c550e3cd.png";